import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchArticleCompare} from '../actions';
import dateHelper from '../../../helpers/dateHelper';
import ArticleCompare from '../components/ArticleCompare';

function mapStateToProps(state, ownProps) {
  const {articleVersions, articleCompare} = state;
  const {dateVersion, lang} = ownProps.params;
  let langArticles = articleVersions.item.filter(function (item) {
    return item.attributes.date === dateVersion;
  });
  let articleCompareId = null;
  if (langArticles.length > 0) {
    articleCompareId = langArticles[0].id;
  }
  return {
    articleCompareId,
    articleCompare,
    lang
  };
}

function mapDispatchToProps(dispatch) {
  return {fetchArticleCompare: bindActionCreators(fetchArticleCompare, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleCompare);



/** WEBPACK FOOTER **
 ** ./src/modules/articles/containers/ArticleCompareVersion.js
 **/